import { Component, input } from '@angular/core';
import { DepositSummary } from '../../../../models/deposits.models';
import { CurrencyFormatPipe } from '@zayan-erp/shared';

@Component({
  selector: 'deal-financial-summary',
  standalone: true,
  imports: [CurrencyFormatPipe],
  templateUrl: './deal-financial-summary.component.html'
})
export class DealFinancialSummaryComponent {
  summary = input<DepositSummary[] | undefined>(undefined);
}
